export default (object) => {
  let query = [];

  for(let key in object) {
    if (object.hasOwnProperty(key)) {
      if (Array.isArray(object[key])) {
        object[key].forEach(val => {
          query.push(`${encodeURIComponent(key)}[]=${encodeURIComponent(val)}`);
        });
      } else {
        if (object[key] === undefined || object[key] === null || object[key] === '') {
          continue;
        }

        query.push(`${encodeURIComponent(key)}=${encodeURIComponent(object[key])}`);
      }
    }
  }

  return query.join("&");
};


// WEBPACK FOOTER //
// ./src/tools/query-stringify.js